/**
 * Etichette e toni della scoperta tematica.
 *
 * File separato dai componenti per la stessa ragione di
 * `analysis-rating.ts`: un modulo che esporta sia componenti sia costanti
 * rompe il Fast Refresh di Vite.
 */

import type { DiscoveryCategory, DiscoveryResolution, DiscoveryRunStatus } from './api';

export const CATEGORY_LABEL: Record<DiscoveryCategory, string> = {
  top_cap: 'Fra i più grandi',
  emerging: 'Emergente',
  trending: 'In movimento',
  core: 'Cuore del tema',
};

/**
 * Toni presi dal sistema esistente (`Badge`): nessun colore nuovo inventato
 * per questa feature. `accent` per il cuore del tema, che è il caso più
 * frequente e non deve gridare.
 */
export const CATEGORY_TONE: Record<DiscoveryCategory, 'positive' | 'negative' | 'neutral' | 'accent'> = {
  top_cap: 'accent',
  emerging: 'positive',
  trending: 'neutral',
  core: 'accent',
};

export const STATUS_LABEL: Record<DiscoveryRunStatus, string> = {
  queued: 'In attesa',
  running: 'In corso',
  completed: 'Completata',
  failed: 'Non riuscita',
};

export const STATUS_TONE: Record<DiscoveryRunStatus, 'positive' | 'negative' | 'neutral' | 'accent'> = {
  queued: 'neutral',
  running: 'accent',
  completed: 'positive',
  failed: 'negative',
};

/**
 * Perché una riga non è azionabile, in parole. Il testo del backend
 * (`resolutionNote`) è più specifico e vince quando c'è: questo è il fondo.
 */
export const RESOLUTION_LABEL: Record<DiscoveryResolution, string> = {
  resolved: 'Identificato',
  ambiguous: 'Identificazione incerta',
  unresolved: 'Non identificato',
};
